import { relationKey, sexKey, type RelationKey } from './relation.js';

/** Relations whose pronoun is fixed by the relation itself — one set of chips, no sex variants. */
const FIXED: ReadonlySet<RelationKey> = new Set(['self', 'son', 'daughter', 'mother', 'father']);

/**
 * i18n keys of the three suggestion chips: `home:chat.chips.<relation>.<variant>.q1..q3`.
 * Fixed-gender relations (self, son, daughter, mother, father) use variant `any`;
 * partner / friend / colleague / other use `sexKey(sex, relation)` (male / female / neutral).
 */
export function chipKeys(relation: string | null, isSelf: boolean, sex: string | null): [string, string, string] {
  const rel = relationKey(relation, isSelf);
  const variant = FIXED.has(rel) ? 'any' : sexKey(sex, relation);
  const base = `home:chat.chips.${rel}.${variant}`;
  return [`${base}.q1`, `${base}.q2`, `${base}.q3`];
}
